import React, { useContext, useEffect, useState } from 'react';
import { BuilderContext, useDrawer, NodeContext } from 'react-custom-flow-builder';
import { Form, Button, Input, Radio, Select, Checkbox, Divider } from 'antd';
import "antd/dist/antd.css";
import { setPreferences, setInsertData } from '../../app/slice/flowBuilderSlice';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import { CaretDownOutlined } from '@ant-design/icons';
import './ConfigPanel.css'
import { json } from 'stream/consumers';
import ConditionForm from "../ConditionForm/ConditionForm"


const { TextArea } = Input;

// Define an interface for the props
interface ConfigFormProps {
  data: {
    load_Flow_Data: boolean
  };
  onUpdateData: (newConfig: any) => void;
  onChange?: (newConfig: any, value: any) => void;
}

const ConfigForm: React.FC<ConfigFormProps> = ({ data, onUpdateData, onChange }) => {
  // const { load_Flow_Data } = data;
  const dispatch = useDispatch();
  const { selectedNode: node } = useContext(BuilderContext);
  const insertData = useSelector((state: any) => state.flowBuilder.insertData);
  const PreferencesObj = useSelector((state: any) => state.flowBuilder.preferences);
  const [localInsert, setLocalInsert] = useState<any>([]);
  const [inputDataArr, setInputDataArr] = useState<any>([]);
  const [showEnvList, setShowEnvList] = useState<boolean>(false);
  const { closeDrawer: cancel, saveDrawer: save } = useDrawer();
  const envList = useSelector((state:any)=>state.flowBuilder.envList);
  const instanceList = useSelector((state:any)=>state.flowBuilder.instanceList);
  const [form] = Form.useForm();

  const [formData, setFormData] = useState<any>({});

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const updatedForm = { ...formData, ...values }
      setFormData(updatedForm);
      save?.(updatedForm);
      if (data.load_Flow_Data) { onUpdateData(inputDataArr) }
    } catch (error) {
      const values = form.getFieldsValue();
      const updatedForm = { ...formData, ...values }
      setFormData(updatedForm);
      save?.(updatedForm, !!error);
      if (data.load_Flow_Data) { onUpdateData(inputDataArr) }
    }
  };

  const el = node?.configElements;

  const checkCatergory = (categoryId: any, item: any) => {

    //check for default category
    if (categoryId == null) { return true; }

    for (const key in PreferencesObj) {
      if (PreferencesObj[key].Id === categoryId) { return true; }
    }
    if ((node?.data) && node?.data[item.name]) {
      node.data[item.name] = "";
    }
    return false;
  }

  const removeCategory = (categoryId: number, LocalPreferencesObj: any) => {
    if (categoryId) {
      for (const key in LocalPreferencesObj) {
        if (LocalPreferencesObj[key].category === categoryId) {
          const itemId = LocalPreferencesObj[key].Id;
          LocalPreferencesObj[key] = "";
          removeCategory(itemId, LocalPreferencesObj);
        }
      }
    }
    return LocalPreferencesObj;
  }

  const updateInputArray = (id: number, value: any, type: string) => {
    const updateObj = {
      "Field_Id": id,
      "Field_Type": type,
      "value": value,
      "FB_Id": node?.id
    }

    setInputDataArr((prevInputDataArr: any) => {
      // Find the index of the existing object with the same Field_Id
      const index = prevInputDataArr.findIndex((item: any) => item.Field_Id === id);

      // If the object exists, replace it; otherwise, push the new object
      if (index !== -1) {
        const updatedArr = [...prevInputDataArr];
        updatedArr[index] = updateObj;
        return updatedArr;
      } else {
        return [...prevInputDataArr, updateObj];
      }
    });
  }


  const handleMultiOptionSelection = async (item: any, e: any) => {
    const propertyId = item.Id;
    const LocalPreferencesObj = JSON.parse(JSON.stringify(PreferencesObj));
    const oldSelectedId = PreferencesObj[propertyId]?.Id;
    const updatedPreferencesObj = await removeCategory(oldSelectedId, LocalPreferencesObj);
    let selectedObj;
    //for ENV list
    if (item?.name == "selected_env" ) {
      const selectedOption = envList.filter((item: any) => item.value === e)[0];
      selectedObj = {
        Id: selectedOption.Id || 0,
        parentId: item.Id || 0,
        category: item.category
      }
    }
    else if (item?.name == "clone_instance" ) {
      const selectedOption = instanceList.filter((item: any) => item.value === e)[0];
      selectedObj = {
        Id: selectedOption.clientId || 0,
        parentId: item.Id || 0,
        category: item.category
      }
    }

    else {
      const selectedOption = item.data.filter((item: any) => item.value === e)[0];
      selectedObj = {
        Id: selectedOption.Id || 0,
        parentId: selectedOption.parentId || 0,
        category: item.category
      }
    }

    console.log("item======", item.data, e)



    updateInputArray(selectedObj.parentId, selectedObj.Id, item.type);
    const updatedValidationObj = { ...updatedPreferencesObj, [propertyId]: selectedObj }
    dispatch(setPreferences(updatedValidationObj));

  }

  const handleShowConditionForm = () => {
    const updatedForm = { ...formData, testCD1: 'asdfa' };
    setFormData(updatedForm);
  }
  const handleTextChange = (item: any, value: string) => {
    updateInputArray(item.Id, value, item.type);
  }

  const getDropdownOptions = (item:any)=>{
    switch (item.name) {
       case "selected_env":
      return [...envList];
      case "clone_instance":
        {console.log(instanceList);
        return [...instanceList];}
      default:
        return item.data ? [...item.data] : [];
    }
  }


  return (
    <>
      <div className='config-section'>
        <Form form={form} className='config-form' >
          {/* <div className='input-div'>
      <label className="floating-label" htmlFor="client-name-input">Name</label>
      <Form.Item name="displayName" initialValue={(node?.data)?node?.data.displayName:node?.name} rules={[{ required: true }]}>
        <Input
          id="client-name-input"
          className='input-field-1'
          required type="text" 
          bordered={false} 

                        
        />
          </Form.Item>
      </div> */}




          {node?.configElements?.map((item: any) => {
            return <>
              {item.type === 'divider' && checkCatergory(item.c_id, item) && (
                <div className="config-section-wrapper">
                  <h2 className="config-section-title">{item.name}</h2>
                </div>
              )
              }

              {item.type === 'text' && checkCatergory(item.c_id, item) &&

                <div className='input-div' key={item}>
                  <label className="floating-label" htmlFor="client-name-input">{item.displayname}</label>
                  <Form.Item name={item.name} initialValue={(node.data) ? node.data[item.name] : ''} rules={[{ required: true }]}>
                    <Input
                      id="client-name-input"
                      className='input-field-1'
                      required type="text"
                      bordered={false}
                      onChange={(e) => handleTextChange(item, e.target.value)}
                    />
                  </Form.Item>
                </div>

              }
              {item.type === 'radio' && checkCatergory(item.c_id, item) &&

                <div className='' key={item}>
                  <label className="floating-label font-sm" htmlFor="client-name-input">{item.displayname}</label>
                  <Form.Item name={item.name} initialValue={(node.data) ? node.data[item.name] : ''} rules={[{ required: true }]}>
                    <Radio.Group >
                      {item.data.map((itemOption: any) => {
                        return <>
                          <Radio className='radio-css' onChange={(e) => { handleMultiOptionSelection(item, e.target.value) }} value={itemOption.value}>{itemOption.label}</Radio>
                        </>
                      })
                      }
                    </Radio.Group>

                  </Form.Item>
                </div>

              }
              {item.type === 'dropdown' && checkCatergory(item.c_id, item) &&

                <div className='input-div' key={item}>
                  <InputLabel id="demo-simple-select-helper-label" className='floating-label'>{item.displayname}</InputLabel>
                  <Form.Item name={item.name} initialValue={(node.data) ? node.data[item.name] : ''} rules={[{ required: true }]}>
                    <Select
                      suffixIcon={<CaretDownOutlined style={{ fontSize: '16px', pointerEvents: 'none' }} rev={undefined} />}
                      id="demo-simple-select-helper"
                      placeholder="Select an option"
                      className='input-field-1'
                      bordered={false}
                      options={getDropdownOptions(item)}
                      onChange={(e) => { handleMultiOptionSelection(item, e) }}
                    />
                  </Form.Item>
                </div>
            

              }
              {/* <Form.Item name="phone" label="Phone" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 6 }}
          />
        </Form.Item>
        <Form.Item name="radio" label="Radio" rules={[{ required: true }]}>
        <Radio.Group>
            <Radio value={1}>A</Radio>
            <Radio value={2}>B</Radio>
            <Radio value={3}>C</Radio>
            <Radio value={4}>D</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="dropdown" label="Dropdown" rules={[{ required: true }]}>
        <Select
          placeholder="Select an option"
            options={[
              {
                value: 'jack',
                label: 'Jack',
              },
              {
                value: 'lucy',
                label: 'Lucy',
              },
              {
                value: 'disabled',
                label: 'Disabled',
              },
              {
                value: 'Yiminghe',
                label: 'yiminghe',
              },
            ]}
          />
        </Form.Item>
        <Form.Item name="checkboxgrp" label="Check boxes" rules={[{ required: true }]}>
          <Checkbox.Group >
                <Checkbox value="A">A</Checkbox>
                <Checkbox value="B">B</Checkbox>
          </Checkbox.Group>
        </Form.Item> */}
              {item.type === 'button' && checkCatergory(item.c_id, item) &&
                <button
                  className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn w-full"
                  type="button"
                  onClick={(e) => handleShowConditionForm()}
                >
                  <div>{item.displayname}</div>
                </button>
              }
            </>;
          })}
          {/* <Form.Item >
        <Button type="primary" onClick={(e)=>handleShowConditionForm}>Test</Button>
      </Form.Item> */}


        </Form>
        <div className='config-footer'>
          <div className='config-controlBtns'>
            <button
              className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
              type="button"
              onClick={cancel}
            >
              <div>Cancel</div>
            </button>
            <button
              className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
              type="button"
              onClick={handleSubmit}
            >
              <div>Save</div>
            </button>
          </div>
        </div>
      </div>


      {/* <ConditionForm 

  
  /> */}
    </>
  );
};

export default ConfigForm;